import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";
import { get } from "../../helpers/api_helper";
import { GET_ACCOUNTANT_HISTORY } from "../../helpers/url_helper";
import "toastr/build/toastr.min.css"; // Make sure this is imported for styling
import accountantColumns from "components/Columns/AccountantHistoryColumns";

const AccountantHistory = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Accountant History", link: "#" },
  ];

  const [customers, setCustomers] = useState([]);
  const [pageIndex, setPageIndex] = useState(1); // Starts at 0
  const [pageSize, setPageSize] = useState(1000); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState([]);
  const [searchText, setSearchText] = useState("");

  async function getAccountantHistoryList(page, size, sort = [], search = "") {
    const sortKey = sort[0]?.id;
    const sortby = sort[0]?.desc ? "desc" : "asc";
    return await get(GET_ACCOUNTANT_HISTORY, {
      params: {
        page,
        size,
        sortKey,
        sortby,
        search,
      },
    });
  }

  const fetchAccountantHistory = async (
    page = 1,
    size = 50,
    sortBy = [],
    searchText
  ) => {
    try {
      const response = await getAccountantHistoryList(
        page,
        size,
        sortBy,
        searchText
      ); // Assuming your API takes page & size
      const { items, totalPages } = response.data;

      setCustomers(items);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    }
  };

  const handleSearchChange = (text) => {
    setPageIndex(1);
    setSearchText(text);
  };

  useEffect(() => {
    fetchAccountantHistory(pageIndex, pageSize, sortBy, searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize, sortBy, searchText]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(() => accountantColumns(), [isAdmin]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Accountant History"
            breadcrumbItems={breadcrumbItems}
          />
        </Container>

        <Card>
          <CardBody>
            {customers.length > 0 && (
              <TableContainer
                columns={columns || []}
                data={customers || []}
                isPagination={true}
                isSortable={true}
                isGlobalFilter={true}
                customPageSize={pageSize}
                isAddOptions={false}
                iscustomPageSize={false}
                isBordered={false}
                controlledPagination={{
                  pageIndex,
                  setPageIndex,
                  pageSize,
                  setPageSize,
                  totalPages,
                }}
                onSortChange={setSortBy}
                searchText={searchText}
                onSearchChange={handleSearchChange}
              />
            )}
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default AccountantHistory;
